export default function getRsvpStep() {
  return window.location.hash.split("/")[2] || 'register';
}



// WEBPACK FOOTER //
// ./src/helpers/getRsvpStep.js